<template>
  <div class="icon icon-cancel-edit" v-html="IconCancelEdit"></div>
</template>

<script>
import IconCancelEdit from './icon-cancel-edit.svg'
export default {
  data () {
    return {
      IconCancelEdit: IconCancelEdit
    }
  }
}
</script>



// WEBPACK FOOTER //
// uncommon-client/components/svgs/IconCancelEdit.vue